import React from "react";
import { TbTargetArrow } from "react-icons/tb";
import { GrAchievement } from "react-icons/gr";
import { BiTask } from "react-icons/bi";
import Navbarss from "../navbars/Navbarss";

function Vocation() {
  return (
    <div>
      <Navbarss />

      <div className="relative w-full">
        {/* Overlay */}
        <div className="absolute inset-0 bg-black opacity-50"></div>

        {/* Background Image */}
        <img
          src="./image/bak.jpg"
          alt="telebirr"
          className="w-full h-[60vh] md:h-[75vh] lg:h-[90vh] object-cover"
        />

        {/* Text Content */}
        <div className="absolute inset-0 flex flex-col justify-center items-center text-gray-500 text-center px-4">
          <h1 className="text-white font-extrabold text-3xl md:text-4xl lg:text-5xl shadow-2xl">
            Vocational Training
          </h1>
          <p className="mt-4 text-white max-w-3xl text-sm sm:text-base md:text-lg leading-relaxed">
            We developed this program to provide vocational skills training
            customized to the individual career interests of each beneficiary.{" "}
            <br />
            The training spans between three and six months and equips our
            select group of youth with industry-sought and applicable
            professional skills.
          </p>
        </div>
      </div>

      <section class=" ">
        <div class="max-w-screen-xl px-4 py-4 mx-auto text-center lg:py-16 lg:px-6">
          <div class="text-center pb-12 rel">
            <h1 class="font-bold text-3xl md:text-4xl lg:text-5xl font-heading text-blue-400">
              Challenge
            </h1>
          </div>
          <figure class="max-w-screen-md mx-auto">
            <p class="text-md  text-gray-900  ">
              The inflated unemployment rate of our developing nation, Ethiopia,
              impel the youth to train in various professions to differentiate
              oneself from other candidates, access a wider range of employment
              opportunities, and boost likelihood of finding a job. Meklit
              Humanitarian Association organized the vocational training program
              to provide its benefactors with relatively short-term professional
              training that will give them a much-needed push in the direction
              of employees’ eyes.
            </p>
          </figure>
        </div>
      </section>
      <section class="  pt-8">
        <div class=" lg:col-span-7 flex justify-center items-center mt-6">
          <p class="max-w-2xl mb-4 text-2xl font-extrabold leading-none md:text-2xl xl:text-2xl  ">
            <a href="/join" className="text-blue-400 font-normal text-center">
              Support Our Project
            </a>
          </p>
        </div>
        <div class="container mx-auto px-4 mb-6">
          <div class="flex flex-wrap">
            <div class="lg:pt-12 pt-6 w-full md:w-4/12 px-4 text-center">
              <div class="max-w-md bg-white rounded-xl overflow-hidden cursor-pointer shadow-lg hover:shadow-2xl hover:scale-105 transform transition-all duration-500 p-2">
                <div class="px-4 py-5 flex-auto">
                  <div class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-blue-400">
                    <BiTask className="w-8 h-8" />
                  </div>
                  <h6 class="text-xl font-semibold">What we do</h6>
                  <p class="mt-2 mb-4 text-blueGray-500">
                    We provide vocational training and follow-up to orthodox
                    youth who are in need and interested in enrolling in
                    vocational programs after they explain their career choices.
                  </p>
                </div>
              </div>
            </div>
            <div class="lg:pt-12 pt-6 w-full md:w-4/12 px-4 text-center">
              <div class="max-w-md bg-white rounded-xl overflow-hidden cursor-pointer shadow-lg hover:shadow-2xl hover:scale-105 transform transition-all duration-500 p-2">
                <div class="px-4 py-5 flex-auto">
                  <div class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-blue-400">
                    <GrAchievement className="w-8 h-8 " />
                  </div>
                  <h6 class="text-xl font-semibold">Achievement </h6>
                  <p class="mt-2 mb-4 text-blueGray-500">
                    53 Orthodox youth from 15 various Addis Church locations who
                    are members of the Ethiopian Orthodox Church have received
                    career-specific vocational skill training since the
                    project's beginning six months ago.
                  </p>
                </div>
              </div>
            </div>
            <div class="lg:pt-12 pt-6 w-full md:w-4/12 px-4 text-center ">
              <div class="max-w-md bg-white rounded-xl overflow-hidden cursor-pointer shadow-lg hover:shadow-2xl hover:scale-105 transform transition-all duration-500 p-2">
                <div class="px-4 py-5 flex-auto">
                  <div class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-blue-400">
                    <TbTargetArrow className="w-8 h-8" />
                  </div>
                  <h6 class="text-xl font-semibold">2025/26 target</h6>
                  <p class="mt-2 mb-16 text-blueGray-500">
                    Meklit Humanitarian Association plans to provide 650 youth
                    from low-income households with vocational training
                    scholarships in their respective field by the Ethiopian 2016
                    (2025/26).
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Vocation;
